import styled from 'styled-components';

import definitions from '../../../Style/LfStyleDefinitions';

const NoInsurances = styled.div`
    font-family: ${definitions.fonts.main};
    font-size: inherit;
    color: ${definitions.colors.almostBlack};

`;


export default NoInsurances;